import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useGlobalContext } from "../../context";
import { useLocation, Link } from "react-router-dom";
import FadeOnScreen from "../../utils/fadeOnScreen";
import localData from "../../localData";
import { Button } from "../../components";

export default function Works() {
    const { fade } = useGlobalContext().animations;

    const location = useLocation();

    useEffect(() => FadeOnScreen.createObserver(), [location]);

    const { worksIcon, workPage1, workPage2, workPage3, workPage4, workPage5 } = localData.images;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <motion.main {...fade} className="works-page">
            <section className="showcase">
                {/* <div className="container info-container">
                    <div className="showcase-icon">
                        <img className="card-image" src={worksIcon} alt="" />
                    </div>
                    <div className="showcase-title-wrapper">
                        <h2 className="showcase-title display-1">
                            We are a Result Driven full-service advertising, design, digital, and media agency.
                        </h2>
                    </div>
                   
                </div> */}
                <div className="container">
                    <div className="card-group">
                        <div className="wrapper" data-lazy-block>
                            <Link to="#/" className="works-card card" data-lazy="fade-up">
                                <img className="card-image" src={workPage1} alt="" />
                            </Link>
                            <a className="works-card card" data-lazy="fade-up">
                                <h4 className="card-title">
                                    Brand Identity Development for LH
                                </h4>
                            </a>
                        </div>
                        <div className="wrapper" data-lazy-block>
                            <Link to="#/" className="works-card card" data-lazy="fade-up">
                                <img className="card-image" src={workPage2} alt="" />
                            </Link>
                            <a className="works-card card" data-lazy="fade-up">
                                <h4 className="card-title">
                                    Website Revamp for Kobo360
                                </h4>
                            </a>
                        </div>
                        <div className="wrapper" data-lazy-block>
                            <Link to="#/" className="works-card card" data-lazy="fade-up">
                                <img className="card-image" src={workPage3} alt="" />
                            </Link>
                            <a className="works-card card" data-lazy="fade-up">
                                <h4 className="card-title">
                                    Brand Identity evelopment and Website Design for Best Seed Link
                                </h4>
                            </a>
                        </div>
                        <div className="wrapper" data-lazy-block>
                            <Link to="#/" className="works-card card" data-lazy="fade-up">
                                <img className="card-image" src={workPage4} alt="" />
                            </Link>
                            <a className="works-card card" data-lazy="fade-up">
                                <h4 className="card-title">
                                    Radio Jingle Production for Kobo 360
                                </h4>
                            </a>
                        </div>
                        <div className="wrapper" data-lazy-block id="works-card-5">
                            <Link to="#/" className="works-card card" data-lazy="fade-up">
                                <img className="card-image" src={workPage5} alt="" />
                            </Link>
                            <a className="works-card card" data-lazy="fade-up">
                                <h4 className="card-title">
                                    We Did it in 3 Campaign for MVX
                                </h4>
                            </a>
                        </div>
                    </div>

                    <div className="wrapper contact-btn-wrapper">
                        <Link to="/contact">
                            <Button className="btn btn-lg btn-outline-light contact-btn">
                                <p>work with experts</p>
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>
        </motion.main>
    );
}
